import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { useTranslation } from 'core/i18n/i18n';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { showErrorNotification } from 'core/utils/notification-service';
import { useEffect } from 'react';
import { OPERATOR_CUSTOM_NOTIFICATIONS_UNAVAILABLE_KEY } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';
import { OperatorCustomNotification } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { getOperatorCustomNotifications } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.service';

const EMPTY_NOTIFICATIONS: OperatorCustomNotification[] = [];

export const useOperatorCustomNotificationsListQuery = (showInactive: boolean) => {
    const { t } = useTranslation();

    const { data, isFetching, isError } = usePocQuery<OperatorCustomNotification[]>({
        queryKey: settingsKeys.operatorCustomNotificationsList(showInactive),
        queryFn: () => getOperatorCustomNotifications(showInactive),
    });

    useEffect(() => {
        if (isError) {
            showErrorNotification(t(OPERATOR_CUSTOM_NOTIFICATIONS_UNAVAILABLE_KEY));
        }
    }, [isError, t]);

    return {
        notifications: data ?? EMPTY_NOTIFICATIONS,
        isLoading: isFetching,
        hasFailedToLoad: isError && data === undefined,
    };
};
